import React from 'react'
import MediaPlayButton from 'components/shared/MediaPlayButton'
import styles from './lazy-youtube.module.scss'

interface LazyYoutubeProps {
    videoId: string
    title?: string
    onPlay: () => void
}

const LazyYoutube: React.FC<LazyYoutubeProps> = ({ videoId, title, onPlay }) => {
    return (
        <div className={styles.lazyYtContainer} data-testid="lazy-youtube-preview" onClick={onPlay}>
            <div className={styles.ytPlayButtonContainer}>
                <MediaPlayButton aria-label="Play YouTube video" />
            </div>
            {title && <div className={styles.videoTitlePill}>{title}</div>}
            <img
                className={styles.original}
                src={`https://img.youtube.com/vi/${videoId}/hqdefault.jpg`}
                alt=""
                data-testid="lazy-youtube-preview-image"
                loading="lazy"
                decoding="async"
            />
        </div>
    )
}

export default LazyYoutube
